import { render, staticRenderFns } from "./shipment-receipt-card.vue?vue&type=template&id=7b3f417e&"
import script from "./shipment-receipt-card.vue?vue&type=script&lang=js&"
export * from "./shipment-receipt-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports